// src/pages/Home/Home.jsx
import React, { useState, useEffect } from "react";
import { Footer, NavBar } from "../../components";
import { db } from "../../config/firebase";
import { ref, onValue } from "firebase/database";
import "./home.scss";
import { GerejaImg } from "../../assets";

// Struktur default untuk Kompelka (tidak berubah)
const initialKompelka = {
  pkb: {
    nama: "Ibadah Pria Kaum Bapa",
    waktu: "Memuat...",
    lokasi: "Memuat...",
  },
  wki: {
    nama: "Ibadah Wanita Kaum Ibu",
    waktu: "Memuat...",
    lokasi: "Memuat...",
  },
  pemuda: {
    nama: "Ibadah Pemuda Jemaat",
    waktu: "Memuat...",
    lokasi: "Memuat...",
  },
  remaja: {
    nama: "Ibadah Remaja Jemaat",
    waktu: "Memuat...",
    lokasi: "Memuat...",
  },
  anak: {
    nama: "Ibadah Anak Sekolah Minggu",
    waktu: "Memuat...",
    lokasi: "Memuat...",
  },
  lansia: { nama: "Ibadah Lansia", waktu: "Memuat...", lokasi: "Memuat..." },
};

const Home = () => {
  const [jadwalMinggu, setJadwalMinggu] = useState({
    // 💡 TAMBAH STATE 'pelayan' di sini
    sesi1: {
      deskripsi: "Ibadah Minggu Sesi 1",
      waktu: "Memuat...",
      pelayan: "Memuat...",
    },
    sesi2: {
      deskripsi: "Ibadah Minggu Sesi 2",
      waktu: "Memuat...",
      pelayan: "Memuat...",
    },
  });
  const [jadwalKompelka, setJadwalKompelka] = useState(initialKompelka);
  const [isLoading, setIsLoading] = useState(true);

  // Hook untuk mengambil data jadwal dari Firebase Realtime Database
  useEffect(() => {
    // --- 1. Ambil Jadwal Minggu ---
    const refMinggu = ref(db, "jadwal_ibadah_minggu");
    const unsubscribeMinggu = onValue(
      refMinggu,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setJadwalMinggu({
            sesi1: {
              deskripsi: data.sesi1?.deskripsi || "Ibadah Minggu Sesi 1",
              waktu: data.sesi1?.waktu || "Jadwal belum diatur",
              // 💡 AMBIL DATA 'pelayan'
              pelayan: data.sesi1?.pelayan || "Pelayan belum diatur",
            },
            sesi2: {
              deskripsi: data.sesi2?.deskripsi || "Ibadah Minggu Sesi 2",
              waktu: data.sesi2?.waktu || "Jadwal belum diatur",
              // 💡 AMBIL DATA 'pelayan'
              pelayan: data.sesi2?.pelayan || "Pelayan belum diatur",
            },
          });
        }
        setIsLoading(false);
      },
      (error) => {
        console.error("Gagal membaca jadwal Minggu dari Firebase:", error);
        setIsLoading(false);
      }
    );

    // --- 2. Ambil Jadwal Kompelka (Tidak Berubah) ---
    const refKompelka = ref(db, "jadwal_ibadah_kompelka");
    const unsubscribeKompelka = onValue(
      refKompelka,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setJadwalKompelka((prev) => ({
            ...prev,
            pkb: data.pkb || prev.pkb,
            wki: data.wki || prev.wki,
            pemuda: data.pemuda || prev.pemuda,
            remaja: data.remaja || prev.remaja,
            anak: data.anak || prev.anak,
            lansia: data.lansia || prev.lansia,
          }));
        } else {
          setJadwalKompelka(
            Object.fromEntries(
              Object.entries(initialKompelka).map(([key, item]) => [
                key,
                {
                  ...item,
                  waktu: "Jadwal belum diatur",
                  lokasi: "Jadwal belum diatur",
                },
              ])
            )
          );
        }
      },
      (error) => {
        console.error("Gagal membaca jadwal Kompelka dari Firebase:", error);
      }
    );

    // Cleanup function untuk kedua listener
    return () => {
      unsubscribeMinggu();
      unsubscribeKompelka();
    };
  }, []);

  // Helper untuk merender card Kompelka (tidak berubah)
  const renderKompelkaCard = (item) => (
    <div key={item.nama} className="kompelka-card">
      <h4>{item.nama}</h4>
      <p>{item.waktu}</p>
      <p className="lokasi-text">Lokasi: {item.lokasi}</p>
    </div>
  );

  return (
    <div className="home-page">
      <NavBar />
      {/* HERO SECTION */}
      <section className="hero-section">
        <img
          src={GerejaImg}
          alt="Gedung GMIM Genesaret"
          className="hero-image"
        />
      </section>

      {/* IBADAH MINGGU SECTION */}
      <section className="ibadah-minggu">
        <p className="small-text">Selamat datang</p>
        <p className="description">
          Mari bersekutu dan beribadah bersama dengan kami di Gedung Gereja GMIM
          Genesaret Pateten pada jadwal berikut:
        </p>

        <div className="card-container">
          {/* 💡 TAMPILKAN PELAYAN DI SINI */}
          <div className="ibadah-card">
            <h4>{jadwalMinggu.sesi1.deskripsi}</h4>
            <p className="waktu-text">{jadwalMinggu.sesi1.waktu}</p>
            <p className="pelayan-text">
              Pelayan Firman: **{jadwalMinggu.sesi1.pelayan}**
            </p>
          </div>
          <div className="ibadah-card">
            <h4>{jadwalMinggu.sesi2.deskripsi}</h4>
            <p className="waktu-text">{jadwalMinggu.sesi2.waktu}</p>
            <p className="pelayan-text">
              Pelayan Firman: **{jadwalMinggu.sesi2.pelayan}**
            </p>
          </div>
        </div>
      </section>

      {/* KOMPELKA SECTION (DINAMIS) */}
      <section className="kompelka-section">
        <p className="highlight">
          Ibadah PKB, WKI, Pemuda, Remaja, Anak Sekolah Minggu & Lansia
        </p>
        <h2>Berikut ini jadwal ibadah kompelka aras jemaat</h2>

        <div className="card-grid">
          {/* Menggunakan data dinamis dari state jadwalKompelka */}
          {Object.values(jadwalKompelka).map(renderKompelkaCard)}
        </div>
      </section>

      {/* HUBUNGI KAMI (Tidak Berubah) */}
      <section className="contact-section">
        <div className="contact-overlay">
          <h2>Hubungi Kami</h2>
          <div className="contact-content">
            <div className="contact-info">
              {/* 1. Alamat */}
              <p>
                <strong>Alamat:</strong> Jl. Raras Tacasily, Pateten Tiga
                <br />
                <a
                  href="https://www.google.com/maps/place/GMIM+Genesaret+Pateten/@1.450499,125.195256,1138m/data=!3m2!1e3!4b1!4m6!3m5!1s0x328701c18dd24327:0x9f284937f72eb608!8m2!3d1.450499!4d125.1978309!16s%2Fg%2F11bv5slxp3?entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D"
                  className="info-link"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Lokasi Google Map
                </a>
              </p>

              {/* 2. Facebook */}
              <p>
                <strong>Facebook:</strong>
                <a
                  href="https://www.facebook.com/gmim.g.pateten"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-link"
                >
                  Gmim Genesaret Pateten
                </a>
              </p>
              {/* 4. Email */}
              <p>
                <strong>Email:</strong>
                genesaretpateten8@gmail.com
              </p>

              {/* 5. Jam Kerja */}
              <p>
                <strong>Jam Kerja Kantor Gereja:</strong>
                Senin - Sabtu <br />
                Pukul 08.00 - 16.00 WITA
              </p>
            </div>
            <div className="contact-map">
              <iframe
                title="gmim-map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4954.5143490424425!2d125.19525597585714!3d1.4504989985358545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x328701c18dd24327%3A0x9f284937f72eb608!2sGMIM%20Genesaret%20Pateten!5e1!3m2!1sid!2sid!4v1760231507405!5m2!1sid!2sid" // Ganti dengan URL embed map yang valid
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER SECTION */}
      <Footer />
    </div>
  );
};
export default Home;
